import React, { useState, useContext } from "react";

import Grid from '@material-ui/core/Grid';

import { useStyles } from './UserTheme';
import UserCard from "./UserCard";
import UserSettingOtherForm from "./UserSettingOtherForm";

// user adatok
import UserContext from "../../context/UserContext";

export default function UserSettingOther() {
  const [rerender, setRerender] = useState(true);
  const classes = useStyles();
  // user adatainak betöltése
  const user = useContext(UserContext);

  return <Grid container direction="row" className={classes.root}>
    {/* {console.log("újra")} */}
    <Grid item className={classes.formContanier}>
      <UserSettingOtherForm useRerender={{ rerender, setRerender }} />
    </Grid>
    <Grid item xs>
      <Grid container className={classes.grund}>
        <UserCard user={user} />
      </Grid>
    </Grid>
  </Grid >;
}